import { StateSchema } from 'app/providers/StoreProvider';

export const addItemsToOrderIsLoading = (state: StateSchema) =>
    state.addItemsToOrder.isLoading;
